import { useQuery } from "react-query";
import { getData } from "../../../../newApis/dotNetApiMethods";

type TQuery = {
  customerId: string | number;
};

export const useGetCustomerPeopleDocumentsForAdmin = ({
  customerId,
}: TQuery) => {
  return useQuery(
    [{ customerId }, "getCustomerPeopleDocumentsForAdmin"],
    async () => {
      if (!customerId) {
        return { funderPeople: [] };
      }
      const data = await getData(
        `/customers/kyc/${customerId}/customer_people_documents?sourceAppId=5`,
      );
      return data?.data || { funderPeople: [] };
    },
    {
      enabled: !!customerId,
    },
  );
};
